export const ACTUALIZAR_LIST_INFORMES = "ACTUALIZAR_LIST_INFORMES";
export const MODIFICAR_INFORMES = "MODIFICAR_INFORMES";
export const AGREGAR_INFORMES = "AGREGAR_INFORMES";  
export const ELIMINAR_INFORMES = "ELIMINAR_INFORMES";